
import React, { useEffect } from 'react';
import StarTracker from '@/components/StarTracker';
import { useLocation } from 'react-router-dom';

const Index: React.FC = () => {
  const location = useLocation();
  const initialTab = location.state?.initialTab || 'tasks';
  const toggleEditMode = location.state?.toggleEditMode;
  
  // Handle edit mode toggle from settings page
  useEffect(() => {
    if (toggleEditMode) {
      // Trigger parent control dialog by dispatching a custom event
      window.dispatchEvent(new CustomEvent('toggleEditMode'));
    }
  }, [toggleEditMode]);
  
  return (
    <StarTracker initialTab={initialTab} />
  );
};

export default Index;
